import { appType } from './config/configHelpers';
import { INTELSAT, PRIMARY_COLOR_BUTTONS, PRIMARY_COLOR_BUTTONS_HOVER, PRIMARY_COLOR_BUTTONS_INTELSAT,
} from './constants';

export const BUTTON_COLOR = (appType === INTELSAT ? PRIMARY_COLOR_BUTTONS_INTELSAT : PRIMARY_COLOR_BUTTONS);
export const BUTTON_HOVER_COLOR = PRIMARY_COLOR_BUTTONS_HOVER;

export const BUTTON_BACKGROUND_COLOR_STYLE = { backgroundColor: BUTTON_COLOR };

export const ACTIVE_BOX_BG_COLOR = "#638DFF"
export const NAV_BOX_BORDER_COLOR = "#D6D8E5"
export const NAV_BOX_TEXT_COLOR = "#404585"
export const BUTTON_COLOR_NEW_UI = "#376AFA"
